




































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const login = namespace("login");
@Component({})
export default class UpdatePasswordSuccess extends Vue {
  @login.Action logout;
  created() {
    localStorage.clear();
    sessionStorage.setItem("accessLogin", "1");
  }
  goLogin() {
    this.$router.push({
      name: "Login"
    });
  }
  async handleLogOut() {
    try {
      // await this.logout();
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  }
}
